import { AssignmentType } from "../assignments/assignment";

export interface PresignedUrlBodyParams {
  fileName: string;
  fileNames?: string[];
  contentType: string;
  fileType: PresignFileType;
  assignmentType?: AssignmentType;
  assignmentId?: string;
  assignmentVersionId?: string;
  jobId?: string;
  isDownload?: boolean;
  packageType?: string;
}

export interface GetS3PresignedUrlResult {
  uploadUrl: string;
  path: string;
}

export enum PresignFileType {
  ASSET = "asset",
  PACKAGE_THUMBNAIL = "package_thumbnail",
  GROUP_THUMBNAIL = "group_thumbnail",
  PACKAGE = "package",
  PROFILE_PICTURE = "profile_picture",
  FILE_HUB = "file_hub",
  USER_IMPORT_JOB = "user_import_job",
}
